<template>
    <main role="main">
        <article class="layout-contents-container">
            <settings-header menu="1"></settings-header>
            <div class="layout-contents">
                <div class="tbl-header">
                    <div class="inner">
                        <h2 class="title">
                            {{ $t('SETTING.WHITELIST.HEADER.TITLE')}}
                            <button type="button" class="buttons-icon" data-type="ghost" data-icon="info" data-size="s" data-trigger="tooltip-right"
                                    v-bind:title="$t('SETTING.WHITELIST.HEADER.TOOLTIP')">
                            </button>
                        </h2>
                        <p class="desc">{{wtlListCnt}} {{ $t('SETTING.WHITELIST.HEADER.DESC')}}</p>
                    </div>

                    <div v-if="getMenuAuth == constants.AUTH_TYPE.EDIT" class="actions">
                        <router-link to="/settings/whitelist/new"  class="buttons" data-type="key" data-size="s" data-icon="add">{{ $t('SETTING.WHITELIST.BUTTON.CREATE_TEMPLATE')}}</router-link>
                    </div>
                </div>

                <div class="tbl-collapse">
                    <div class="thead">
                        <div class="row">
                            <span class="cell">
                                <button type="button" class="buttons-tbl-header"
                                        v-bind:data-type="sortColumn !== 'titl' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'" v-on:click="setSortColumn('titl')"
                                >{{ $t('SETTING.WHITELIST.TABLE.NAME')}}</button>
                            </span>
                            <span class="cell" data-size="status" data-align="center">
                                <button type="button" class="buttons-tbl-header tooltipstered" data-type="filter" data-tooltip-content="#tooltip-use-filter">{{ $t('SETTING.WHITELIST.TABLE.STATUS')}}</button>
                                    <div class="tooltip_templates">
                                    <div id="tooltip-use-filter">
                                        <ul class="list-filter">
                                            <li>
                                                <input type="checkbox" id="sche_value_all" name="filter-type" class="checkbox" v-model="searchUseType" value="Y">
                                                <label for="sche_value_all">{{$t('SETTING.WHITELIST.LABEL.ENABLED')}}</label>
                                            </li>
                                            <li>
                                                <input type="checkbox" id="sche_value_a" name="filter-type" class="checkbox" v-model="searchUseType" value="N">
                                                <label for="sche_value_a">{{$t('SETTING.WHITELIST.LABEL.DISABLED')}}</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </span>
                            <span class="cell" data-size="date" data-align="center">
                                <button type="button" class="buttons-tbl-header"
                                        v-bind:data-type="sortColumn !== 'creaDt' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'" v-on:click="setSortColumn('creaDt')">{{ $t('SETTING.WHITELIST.TABLE.CREA_DT')}}</button>
                            </span>
                            <span class="cell" data-size="user" data-align="center">
                                <button type="button" class="buttons-tbl-header"
                                        v-bind:data-type="sortColumn !== 'creaUserNm' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'" v-on:click="setSortColumn('creaUserNm')">{{ $t('SETTING.WHITELIST.TABLE.CREA_USER')}}</button>
                            </span>
                            <span class="cell" data-size="date" data-align="center">
                                <button type="button" class="buttons-tbl-header"
                                        v-bind:data-type="sortColumn !== 'updtDt' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'" v-on:click="setSortColumn('updtDt')">{{ $t('SETTING.WHITELIST.TABLE.UPDT_DT')}}</button>
                            </span>
                            <span class="cell" data-size="user" data-align="center">
                                <button type="button" class="buttons-tbl-header"
                                        v-bind:data-type="sortColumn !== 'updtUserNm' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'" v-on:click="setSortColumn('updtUserNm')">{{ $t('SETTING.WHITELIST.TABLE.UPDT_USER')}}</button>
                            </span>
                            <span v-if="getMenuAuth == constants.AUTH_TYPE.EDIT" class="cell" data-size="console" data-align="center">
                                {{ $t('COMMON.TABLE.OPTIONS')}}
                            </span>
                            <span class="cell" data-size="expand" data-align="center">
                                {{ $t('COMMON.TABLE.DETAILS')}}
                            </span>
                        </div>
                    </div>
                    <div v-if="wtlList.length > 0" class="tbody">
                        <WhitelistCells v-for="(wtl,idx) in wtlList" :key="idx"
                            :whiteList="wtl"
                            :cmpnId="curCmpnId"
                            :menuAuth="getMenuAuth"
                            :callSelectWhitelistList="selectWhitelistList"
                            :callDeleteWhitelist="openDialog"
                        />
                    </div>
                    <div v-if="!pending && wtlList.length == 0" class="tbody">
                        <div class="row none">
                            <div class="cells">
                                <div class="cell">
                                    {{$t('SETTING.WHITELIST.MESSAGE.NONE')}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article>
        <div-loading v-if="pending" :full="true"></div-loading>
        <Modal
            :okFunction="handleModalOkFunc"
            :title="modal.popupTitle"
            :message="modal.popupMessage"
            :isShowPopup="modal.isShowPopup"
            :callOnHide="handleHideModal"
            :btnOkStyle="modal.btnOkStyle"
            :isOKOnly="modal.isOKOnly"
        />
    </main>
</template>

<script>

    import settingsHeader from "./settingsHeader.vue";
    import WhitelistCells from "./settingComponents/WhitelistCells.vue";
    import Modal from "../common/Modals/Modal.vue";
    import {mapGetters} from "vuex";

    export default {
        name: 'settings-whitelist',
        components: {
            settingsHeader,
            WhitelistCells,
            Modal
        },
        data: function() {
            return {
                modal: {
                    isShowPopup: false
                },
                pending: false,
                sortColumn: '',                 // Sort column
                sortOrder: '',
                wtlRawList:[],
                wtlList:[],
                wtlListCnt:0,
                searchUseType:['Y','N']
            }
        },
        created: function(){
            this.selectWhitelistList();
            this.$store.dispatch('sse/completeSseEventSource');
        },
        watch:{
            curCmpnId: function(){
                this.selectWhitelistList();
            },
            searchUseType() {
                this.getWhitelistlist();
            }
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId'
            }),
            getMenuAuth: function(){
                //메뉴 별 권한
                let auth = _.find(this.$store.state.GOV_MENU_AUTH, {menuId: this.constants.MENU.SETTINGS})
                return auth ? auth.authTypeCd : this.constants.AUTH_TYPE.NONE
            },
            getLocale: function() {
                return this.$i18n.locale
            }
        },
        methods: {
            handleHideModal() {
                this.modal = {};
                this.modal.isShowPopup = false;
            },
            handleModalOkFunc() {
                this.deleteWhitelist();
            },
            async deleteWhitelist() {
                this.pending = true;
                const header = {
                    "cmpnId": this.curCmpnId,
                    "wtlId": this.modal.wtl.wtlId,
                    "delYn": "Y"
                };

                const url = "/api/governance/setting/whitelist/delete";

                try {
                    const response = await this.http.post(url,JSON.stringify(header));
                    if(response.data.status === 'ok') {
                        this.selectWhitelistList();
                    }
                } catch(err) {
                    console.err("deleteWhitelist: ", err)
                } finally {
                    this.pending = false;
                }
            },
            initView(){
                let target = $('[data-trigger="tooltip-right"]');
                target.tooltipster({
                    delay: 300,
                    // trigger: 'click',
                    animation: 'fade',
                    updateAnimation: 'fade',
                    position: 'right',
                    arrow: true,
                    contentAsHTML: true,
                    interactive: true
                });
            },
            getWhitelistlist: function() {
                let self = this;
                this.wtlList  = _.cloneDeep(self.wtlRawList);

                if(this.searchUseType.length > 0 && this.searchUseType.length <2) {
                    this.wtlList = this.wtlList.filter((p) => {
                        if(_.includes(this.searchUseType, 'Y') && p.useCnt > 0){
                            p.filter = true;
                        }

                        if(_.includes(this.searchUseType, 'N') && p.useCnt === 0){
                            p.filter = true;
                        }
                        return p.filter === true;
                    })
                }

                if (this.sortColumn !== '' && this.sortOrder !== '') {
                    this.wtlList = _.orderBy(self.wtlRawList, [wtl=> wtl[self.sortColumn] != null ? wtl[self.sortColumn].toLowerCase() : wtl[self.sortColumn]], [self.sortOrder])
                }

            },
            selectWhitelistList: function () {
                this.pending = true;
                let url = `/api/governance/setting/whitelist`;
                let header = {
                    "cmpnId":this.curCmpnId
                };

                this.http.post(url, JSON.stringify(header))
                    .then(response => {
                        this.pending = false;
                        if(response.data.status === 'ok'){
                            this.wtlRawList = response.data.result.list;
                            this.wtlListCnt = response.data.result.cnt;
                            this.$nextTick(function () {
                                this.initView();
                                this.getWhitelistlist();
                                this.initMultiFilter();
                            })
                        }
                    });
            },
            openDialog(wtl){
                this.modal = {
                    popupTitle: this.$t('SETTING.WHITELIST.POPUP.TITLE.DELETE_WHITELIST'),
                    popupMessage: this.$t('SETTING.WHITELIST.POPUP.DESC.DELETE_WHITELIST'),
                    isShowPopup: true,
                    btnOkStyle: 'danger',
                    wtl: wtl
                }
            },
            setSortColumn: function (sortColumn) {
                const sortResult = this.Common.setSortColumn(this.sortColumn, this.sortOrder, sortColumn);
                this.sortColumn = sortResult.sortColumn;
                this.sortOrder= sortResult.sortOrder;
                this.getWhitelistlist();
            },
            convertUtcTimezoneToLocal: function(date) {
                return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
            },
            initMultiFilter: function() {
                let self = this;
                // tooltipster 생성
                let $filterTarget = $('.tbl-collapse .buttons-tbl-header[data-type=filter]')

                $filterTarget.tooltipster({
                    animation: 'fade',
                    side: 'bottom',
                    theme: 'go-filter',
                    interactive: true,
                    trigger: 'click',
                    functionBefore: function(instance, helper) {
                        $(helper.origin).addClass("selected");
                    },
                    functionAfter: function(instance, helper) {
                        $(helper.origin).removeClass("selected");
                    },
                    functionPosition: function(instance, helper, position) {
                        position.coord.top -= 7;
                        position.coord.left = helper.geo.origin.offset.right - position.size.width;
                        return position;
                    }
                });

            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/settings/settingsWhitelist.vue